import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import { FEMALE, MALE } from 'constants';
import { Fade } from 'helpers/animation';
import useFormInput from 'hooks/form/useFormInput';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputGenderRadioValidation = ({
  field,
  information,
  setInformation,
  validation,
  setValidation,
}) => {
  const { t } = useLang();

  const isMale = information[field.name] === MALE;
  const isFemale = information[field.name] === FEMALE;

  const {
    setInformationFormInput,
    setValidationFormInput,
    FormLabel,
    FormControlFeedback,
  } = useFormInput(field);

  const handleOnChange = (e, value) => {
    e.preventDefault();
    e.stopPropagation();

    setInformationFormInput({
      value,
      information,
      setInformation,
    });

    setValidationFormInput({
      validation,
      setValidation,
      isReset: true,
    });
  };

  const renderFormCheckRadio1 = () => {
    const formCheckRadioClassName1 = field.name + '1';
    return (
      <FormCheckboxRadioStyled
        name={field.name}
        className={`${formCheckRadioClassName1} ${isMale ? 'active' : ''}`}
        label={t('form_gender_male')}
        isChecked={isMale}
        isInvalid={validation[field.name]}
        onClick={(e) => handleOnChange(e, MALE)}
      />
    );
  };

  const renderFormCheckRadio2 = () => {
    const formCheckRadioClassName2 = field.name + '2';
    return (
      <FormCheckboxRadioStyled
        name={field.name}
        className={`${formCheckRadioClassName2} ${isFemale ? 'active' : ''}`}
        label={t('form_gender_female')}
        isChecked={isFemale}
        isInvalid={validation[field.name]}
        onClick={(e) => handleOnChange(e, FEMALE)}
        styles={{ marginRight: 0 }}
      />
    );
  };

  return (
    <FormGroupStyled>
      <FormLabel styles={{ marginBottom: '4px' }} />
      {renderFormCheckRadio1()}
      {renderFormCheckRadio2()}
      <FormControlFeedback value={t(validation[field.name])} />
      <FormControlFeedback
        value={t(validation[field.name])}
        validationStyles={{ position: 'unset' }}
      />
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  position: relative;
  ${Fade};
`;

const FormCheckboxRadioStyled = styled(FormCheckboxRadio)`
  &.active {
    & label {
      font-weight: 500;
    }
  }
`;

export default FormInputGenderRadioValidation;
